import { environmentConfig } from "@src/appV2/environment";
import { Shift } from "@src/lib/interface";
import request from "superagent";

import { getAuthHeader } from "../../superagent";

export const getUpcomingShiftsGrouped = async (): Promise<
  | {
      [key: string]: Shift;
    }
  | undefined
> => {
  return request
    .get(`${environmentConfig.REACT_APP_BASE_API_URL}/v1/shifts/upcomingShiftsGrouped`)
    .set(await getAuthHeader())
    .retry(1, (err) => {
      if (!err) {
        return false;
      }
      return true;
    })
    .then(({ body }) => body?.response);
};
